/**
 * Global Modal Stack
 * 
 * Public API for the global modal stack system.
 * 
 * @example
 * import { GlobalModalStackProvider, useGlobalModalStack, GLOBAL_MODAL_IDS, MODAL_IDS, ModalContainer } from "@west-tennessee-consulting/ui";
 * 
 * // In your app root
 * <GlobalModalStackProvider syncWithUrl>
 *   <App />
 * </GlobalModalStackProvider>
 * 
 * // In your components
 * const { openModal, closeModal, isModalOpen } = useGlobalModalStack();
 */

// Main exports
export { GlobalModalStackProvider } from "./GlobalModalStackProvider.js";
export { useGlobalModalStack, GlobalModalStackContext } from "./context.js";
export { GLOBAL_MODAL_IDS, MODAL_IDS } from "./constants.js";
export { ModalContainer } from "./ModalContainer.js";

// Type exports
export type { GlobalModalId, GlobalModalStackContextType, GlobalModalStackProviderProps } from "./types.js";
export type { ModalContainerProps } from "./ModalContainer.js";

// Hook exports (for advanced usage)
export { useModalDataStore } from "./hooks/useModalDataStore.js";
export { useUrlSync } from "./hooks/useUrlSync.js";
export { useModalActions } from "./hooks/useModalActions.js";

// Type exports for hooks (for advanced usage)
export type { ModalDataStoreReturn } from "./hooks/useModalDataStore.js";
export type { UrlSyncReturn } from "./hooks/useUrlSync.js";
export type { ModalActionsReturn } from "./hooks/useModalActions.js";
